var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-4" }, [
      _c("label", { attrs: { for: _vm.$id } }, [
        _vm._v(
          "\n            " + _vm._s(_vm.question.description) + "\n        "
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-8" },
      [
        _vm.question.displayType === "textarea"
          ? _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.valueModel,
                  expression: "valueModel"
                }
              ],
              staticClass: "w-100",
              attrs: { id: _vm.$id, readonly: _vm.readonly },
              domProps: { value: _vm.valueModel },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.valueModel = $event.target.value
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.question.displayType === "radiobutton"
          ? _vm._l(_vm.question.options, function(option, index) {
              return _c(
                "div",
                { staticClass: "form-check form-check-inline" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.valueModel,
                        expression: "valueModel"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "radio",
                      id: _vm.$id + "_" + index,
                      name: _vm.$id + "_" + index,
                      disabled: _vm.readonly
                    },
                    domProps: {
                      value: option.value,
                      checked: _vm._q(_vm.valueModel, option.value)
                    },
                    on: {
                      change: function($event) {
                        _vm.valueModel = option.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: _vm.$id + "_" + index }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(option.label) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }